/*global event, fdescribe*/
/*eslint no-restricted-globals: ["error", "event", "fdescribe"]*/

export default () => {
	self.importScripts(self.origin + "/assets/js/CommonLayout.js");
	self.addEventListener(
		"message",
		event => {
			let args = event.data;
			self.postMessage(self.createFlatItemsPage.apply(null, args));
		},
		false
	);

	self.createFlatItemsPage = (
		layoutWidth,
		layoutTop,
		itemWidth,
		itemHeight,
		verticalMargin,
		itemsPerRow,
		containerZoom,
		itemsPerPage,
		totalPages
	) => {
		const calcVerticalMargin = self.CommonLayout.getVerticalMargin(
			layoutWidth,
			itemWidth,
			verticalMargin,
			itemsPerRow
		);
		const pageHeight = self.CommonLayout.getPageHeight(
			layoutWidth,
			itemWidth,
			itemHeight,
			verticalMargin,
			itemsPerRow,
			containerZoom,
			itemsPerPage
		);
		const marging = (calcVerticalMargin / 2) * containerZoom + 7;
		const calcLayoutTop = layoutTop * containerZoom;
		let flatPages = [];

		for (let page = 0; page < totalPages; page++) {
			const flatPage = pageHeight * page - marging + calcLayoutTop;
			flatPages.push(flatPage);
		}
		return flatPages;
	};
};
